var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 750,
    viewBox: "0 0 1400 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1400,
    height: 750
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1400V750H0V0Z",
    fill: "#F5F7FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 742,
    cy: 512,
    r: 189,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.851 668.5L471.15 447.924L615.58 568.814L636.586 540.141L970.283 655.191L697.021 603.917L626.421 645.88L553.856 611.018L516.851 668.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.348 584.998C325.094 585.074 336.257 581.221 350.981 575.562C352.151 575.133 378.891 515.964 378.891 515.964L354.724 575.131L361.334 572.148L372.374 546.816L363.133 572.331L367.466 570.243L375.397 549.167L368.283 570.192L456.127 532.285L450.334 592.151L462.745 621.596L476.718 654.721L490.983 688.569L434.266 620.813L428.677 573.585L412.828 573.15L414.405 556.847L352.274 593.339L292.649 649.665L230.088 666.342L76.4756 696.683L303.232 551.95L320.262 574.245L322.348 584.998Z",
    fill: "#EAD4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.45 692.065L1368.83 691.936L1377.27 646.666L1378.09 692.193L1373.45 692.065Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.46 691.549L1357.92 691.43L1366.91 636.342L1367.01 691.669L1362.46 691.549Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.42 688.575L1379.93 688.464L1389.41 624.608L1388.91 688.686L1384.42 688.575Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.45 699.136L1395.83 699.007L1404.27 653.737L1405.09 699.264L1400.45 699.136Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.01 688.82L1385.39 688.692L1393.83 643.422L1394.65 688.949L1390.01 688.82Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.66 704.252L1319.02 704.123L1327.48 658.854L1328.29 704.38L1323.66 704.252Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.66 703.736L1308.12 703.617L1317.11 648.529L1317.21 703.856L1312.66 703.736Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.62 700.763L1330.12 700.652L1339.61 636.795L1339.12 700.874L1334.62 700.763Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.66 711.323L1346.02 711.194L1354.48 665.925L1355.3 711.452L1350.66 711.323Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.22 701.007L1335.58 700.879L1344.04 655.609L1344.85 701.136L1340.22 701.007Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.72 706.104L1357.22 705.992L1366.6 643.868L1366.22 706.217L1361.72 706.104Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.71 708.864L1357.09 708.736L1365.53 663.466L1366.35 708.993L1361.71 708.864Z",
    fill: "#486E87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3555 679.796L-2.28022 679.668L6.17283 634.387L6.98144 679.925L2.3555 679.796Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.38425 675.645L-12.9479 675.523L-4.17752 624.064L-3.79496 677.705L-8.38425 675.645Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8633 684.885L8.40973 684.782L18.35 612.32L17.3168 684.988L12.8633 684.885Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 686.867L24.7198 686.739L33.1728 641.458L33.9814 686.996L29.3555 686.867Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4319 685.13L13.87 685.01L22.8089 631.134L22.9841 685.25L18.4319 685.13Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9469 690.354L35.4862 690.249L45.3425 619.393L44.4075 690.458L39.9469 690.354Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1576 688.779L35.5612 688.654L44.2653 638.995L44.7539 688.903L40.1576 688.779Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1637 703.234L70.333 703.09L77.7623 674.673L80.0046 703.378L75.1637 703.234Z",
    fill: "#067C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.526 705.514L88.6953 705.37L96.1247 676.953L98.3669 705.658L93.526 705.514Z",
    fill: "#067C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.464 698.344L59.6226 698.199L67.0631 669.783L69.3054 698.488L64.464 698.344Z",
    fill: "#067C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.71 740.345L1228.09 740.217L1236.53 694.947L1237.35 740.474L1232.71 740.345Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.72 739.83L1217.17 739.711L1226.17 684.622L1226.27 739.95L1221.72 739.83Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.68 736.856L1239.19 736.745L1248.67 672.889L1248.17 736.967L1243.68 736.856Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.72 747.417L1255.09 747.288L1263.54 702.019L1264.35 747.545L1259.72 747.417Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.27 737.101L1244.65 736.973L1253.09 691.703L1253.91 737.23L1249.27 737.101Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.78 742.198L1266.27 742.085L1275.66 679.962L1275.27 742.31L1270.78 742.198Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.77 744.958L1266.14 744.829L1274.59 699.56L1275.4 745.086L1270.77 744.958Z",
    fill: "#55682B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.658 881.198C381.776 846.666 382.643 799.715 380.955 747.964L393.321 764.572L398.061 882.853L376.658 881.198Z",
    fill: "#BAD188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.1456 509.058L93.2427 452.75L445.872 682.13L748.075 711.347L943.463 544.773L1004.01 579.708C1031.07 595.323 1063.48 598.916 1094.72 589.766L1222.18 552.421L1393.15 773.627L1357.35 1143.83L-83.7107 1104.29L-26.1456 509.058Z",
    fill: "#F0EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.4559 453.155L178.744 571.072L482.424 438.12L979.677 644.074L1135.21 608.059L1261.36 528.636L1422.93 442.487L1413.09 543.724L1354.75 1143.86L-83.7121 1103.91L-20.4559 453.155Z",
    fill: "#F6F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-42.9953 683.297L4.12427 557.209L52.5468 616.776L50.0897 642.182L109.849 667.051L463.686 462.914L473.948 531.89L468.156 591.776L522.484 720.66L566.901 656.362L614.756 686.788L670.578 665.515L614.692 584.261L686.025 659.631L711.88 649.775L574.338 534.644L737.114 640.157L748.376 635.868L1033.61 698.281L1097.47 682.796L1063.26 725.697L1104.22 681.162L1115.05 678.536L1057.1 742.741L1121.89 679.621L1130.41 676.871L1104.37 720.759L1136.94 675.788L1276.37 639.439L1418.07 515.946L1357.35 1143.86L-83.7121 1104.32L-52.0548 776.974L-42.9953 683.297Z",
    fill: "#F0EEFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/Main_BG.f5b0aae7f301df9b01141979a5132b78.svg";
export { ForwardRef as ReactComponent };